export default "__VITE_ASSET__D0NbBoS7__"